import { combineReducers } from "@reduxjs/toolkit";
import SpecialistAuthModule from "./modules/specialist/auth";
import MasterModule from "./modules/master";
import AdminAuthModule from "./modules/admin/auth";
import AdminDataModule from "./modules/admin/data";
import AdminScreenModule from "./modules/admin/screen";

const rootReducer = combineReducers({
  master: MasterModule.reducer,
  specialistAuth: SpecialistAuthModule.reducer,
  adminAuth: AdminAuthModule.reducer,
  adminData: AdminDataModule.reducer,
  adminScreen: AdminScreenModule.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
